import { forwardRef, type TextareaHTMLAttributes } from "react";

const TextArea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(
  function TextArea({ className = "", rows = 4, ...rest }, ref) {
    return <textarea ref={ref} rows={rows} className={`bo-textarea ${className}`} {...rest} />;
  },
);

export default TextArea;
